import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var AppFormItem = /*#__PURE__*/function (_Vue) {
  _inherits(AppFormItem, _Vue);

  var _super = _createSuper(AppFormItem);

  function AppFormItem() {
    _classCallCheck(this, AppFormItem);

    return _super.apply(this, arguments);
  }

  return AppFormItem;
}(Vue);

__decorate([Prop(String)], AppFormItem.prototype, "label", void 0);

__decorate([Prop({
  type: [Number, String],
  default: '100'
})], AppFormItem.prototype, "width", void 0);

__decorate([Prop(String)], AppFormItem.prototype, "hint", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppFormItem.prototype, "required", void 0);

__decorate([Prop(String)], AppFormItem.prototype, "color", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppFormItem.prototype, "showhint", void 0);

AppFormItem = __decorate([Component({})], AppFormItem);
export default AppFormItem;